module.exports = __webpack_public_path__ + "img/settings.5e4d9176.svg";